<ds-error-page
  [attr.error-page-title]='isUnauthorized ? ("errorPage.title" | translate) : ("errorNotFound.title" | translate)'
  [attr.error-page-subtitle]='"Oh no!"'
  [attr.error-page-description]='isUnauthorized ? ("errorPage.description" | translate) : ("errorNotFound.description" | translate)'
  [attr.error-page-image]='errorPageImage'
  [attr.error-page-image-alt]='isUnauthorized ? ("errorPage.imageAlt" | translate) : ("errorNotFound.imageAlt" | translate)'
  [attr.error-page-link-text]='isUnauthorized ? ("errorPage.linkText" | translate) : ("errorNotFound.linkText" | translate)'
  [attr.error-page-link-url]='isUnauthorized ? "https://snam.service-now.com/helpy" : "/dashboard"'
  [attr.error-page-link-icon]='"icon-arrow-right"'
  [attr.error-page-link-is-external]='isUnauthorized ? "true" : "false"'
  [attr.error-page-link-is-router]='isUnauthorized ? "false" : "true"'
  [attr.error-page-variant]='isUnauthorized ? "unauthorized" : "not-found"'
  [attr.has-textlink-animation]='false'
></ds-error-page>